'use strict';

const BasePresenter = require('./base');

class QuantityPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    if (this.model) {
      return {
        selected:
          this.options && this.options.selected && this.options.selected.getPartySize() === this.model.getPartySize(),
        quantity: this.model.getPartySize(),
      };
    } else {
      return false;
    }
  }
}

module.exports = QuantityPresenter;
